import { useState } from "react";

import { Icon } from "@blueprintjs/core";
import { Link } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import { buildCompanyUrlPath } from "@/components/pieces/company-detail/buildCompanyUrlPath";
import { LIGHT_PURPLE, PURPLE } from "@/css/constants";
import { Company } from "@/types/companies";

export function DefaultCompanyLogo({ width = 40, iconSize = 20 }) {
  return (
    <Flex
      style={{ borderRadius: "100%", backgroundColor: LIGHT_PURPLE }}
      width={width}
      height={width}
      justifyContent="center"
      alignItems="center"
    >
      <Icon icon="briefcase" size={iconSize} color={PURPLE} />
    </Flex>
  );
}

interface CompanyLogoProps {
  company: Company;
  width?: number;
  enforceMaxWidth?: boolean;
  useLink?: boolean;
  borderRadius?: number;
  defaultLogo?: string;
  style?: React.CSSProperties;
  className?: string;
  customerId?: string;
  embed?: boolean;
}

export function CompanyLogo({
  company,
  width = 40,
  enforceMaxWidth = true,
  useLink = true,
  borderRadius = 0,
  defaultLogo,
  style = {},
  className,
  customerId,
  embed = false,
}: CompanyLogoProps) {
  const companyLogo = company.companyLogo || company.logo_url;
  const [hasError, setHasError] = useState(false);
  const content =
    companyLogo && !hasError ? (
      <img
        draggable={false}
        style={{
          maxWidth: enforceMaxWidth ? width : undefined,
          objectFit: "cover",
          objectPosition: "0 100%",
          maxHeight: width,
        }}
        onError={() => setHasError(true)}
        src={companyLogo}
      />
    ) : (
      defaultLogo || <DefaultCompanyLogo width={width} iconSize={16} />
    );
  return (
    <Box
      style={{ overflowX: "hidden", minWidth: width, borderRadius, ...style }}
      width={enforceMaxWidth ? width : undefined}
      className={className}
    >
      {useLink ? (
        <Link to={buildCompanyUrlPath({ company, customerId, embed })}>
          {content}
        </Link>
      ) : (
        content
      )}
    </Box>
  );
}
